import { EditorHost } from '../providers';
export const isStudioHost = editorHost => editorHost === EditorHost.studio;
export const isClassicEditorHost = editorHost => editorHost === EditorHost.editor;
export const isEditor3Host = editorHost => editorHost === EditorHost.odeditor;
//# sourceMappingURL=get-editor-host.js.map